var img = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 10'%3e%3cpath fill='white' d='M0 0h16v10H0z'/%3e%3cpath fill='crimson' d='M0 5h16v5H0z'/%3e%3c/svg%3e";
  export default img;